import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';
import NoteType from '@/models/Notes/NoteType';

export default class UpdatePositionRequest extends BaseUpdateRequest {
    description: string;
    type: NoteType;
    noteCategoryId: string;
}